import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { cx } from 'class-variance-authority';
import parse from 'html-react-parser';
import { useState } from 'react';

import { useDataModel } from '@/hooks/useDataModel';
import { DataModelAttribute } from '@/types/DataModel';

import { IconButton } from '../core/IconButton';
import { getMemberAttributes } from '../datamodel/Collection/useMemberAttributes';
import { useGroupTitle } from '../datamodel/hooks/useGroupTitle';
import CatalogAttribute from './CatalogAttribute';

const GroupRender = ({attribute, attributeData}: {
    attribute: DataModelAttribute,
    attributeData:any
}) => {
    const { dataModel } = useDataModel();
    const memberAttributes = getMemberAttributes(attribute, dataModel);

    return attributeData.map((groupData: any, index:number) =>
    {
        return <CollapsibleGroup attribute={attribute}  index={index} memberAttributes={memberAttributes} currentValue={attributeData} key={index}>
            {
                Object.entries(groupData).map(([key]: any) => {
                    if (memberAttributes){
                        const attrIndex = memberAttributes.findIndex((entry) => entry.name == key);
                        return <CatalogAttribute key={key} attribute={memberAttributes[attrIndex]} item={groupData} />;}
                })
            }
        </CollapsibleGroup>;}
    );
};

const CollapsibleGroup = ({ attribute, index, memberAttributes, currentValue, children }: {
    attribute : DataModelAttribute,
    index: number,
    memberAttributes: any,
    currentValue: any,
    children: any
}) => {
    const [isOpen, setIsOpen] = useState(true);

    const getEntryTitle = useGroupTitle({
        attribute,
        index,
        memberAttributes,
        currentValue
    });

    return (
        <div className="tw-mb-4">
            <div
                className="tw-flex tw-items-center tw-w-full tw-p-2 tw-rounded-md tw-cursor-pointer"
                onClick={() => setIsOpen(!isOpen)}
            >
                <ArrowIcon isOpen={isOpen} />
                <span className="group-title-label">{parse(getEntryTitle ?? '')}</span>
            </div>
            {isOpen && <div className="tw-pl-6 tw-mt-2">{children}</div>}
        </div>
    );
};

const ArrowIcon = ({ isOpen }: { isOpen: boolean }) => {
    const baseClass =
        'tw-cursor-pointer tw-mr-1 tw-select-none tw-border-0 tw-rounded-md tw-px-2 tw-py-1 tw-text-xs !tw-text-black';
    const classes = cx(baseClass, {
        ['tw--rotate-90 tw-transform tw-origin-center']: !isOpen,
    });

    return (
        <IconButton className={classes} icon={ChevronDownIcon} type="button" />
    );
};

export default  GroupRender;
